import { Button } from "@/components/ui/button";
import { Phone, MessageCircle, Mail } from "lucide-react";
import { FlashBuyButton } from "@/components/FlashBuyButton";

export const FinalCTA = () => {
  return (
    <section className="py-12 md:py-20 bg-gradient-to-b from-primary/5 to-background">
      <div className="container max-w-4xl text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-foreground mb-4">
          Ainda com dúvidas?
        </h2>
        <p className="text-lg text-muted-foreground mb-8">
          Nossa equipe de especialistas está pronta para ajudar você a escolher
          o certificado digital ideal
        </p>

        <div className="grid md:grid-cols-3 gap-4 mb-8">
          <Button
            variant="outline"
            size="lg"
            className="flex items-center gap-2 h-auto py-4"
            onClick={() => window.open("https://wa.me/551152397247", "_blank")}
          >
            <MessageCircle className="w-5 h-5" />
            <div className="text-left">
              <p className="font-semibold">WhatsApp</p>
              <p className="text-xs text-muted-foreground">
                Resposta imediata
              </p>
            </div>
          </Button>

          <Button
            variant="outline"
            size="lg"
            className="flex items-center gap-2 h-auto py-4"
            onClick={() => window.open("tel:+551152397247", "_blank")}
          >
            <Phone className="w-5 h-5" />
            <div className="text-left">
              <p className="font-semibold">(11) 5239-7247</p>
              <p className="text-xs text-muted-foreground">Seg a Sex, 8h-18h</p>
            </div>
          </Button>

          <Button
            variant="outline"
            size="lg"
            className="flex items-center gap-2 h-auto py-4"
            onClick={() =>
              window.open("mailto:suporte@certificadoradigital.com", "_blank")
            }
          >
            <Mail className="w-5 h-5" />
            <div className="text-left">
              <p className="font-semibold">E-mail</p>
              <p className="text-xs text-muted-foreground">
                Respondemos em 2h
              </p>
            </div>
          </Button>
        </div>

        <div className="bg-card border border-border rounded-lg p-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-left">
              <p className="font-semibold text-foreground mb-1">
                Garantia de satisfação
              </p>
              <p className="text-sm text-muted-foreground">
                Devolução em até 7 dias se não ficar satisfeito
              </p>
            </div>
            <FlashBuyButton size="lg" className="whitespace-nowrap" />
          </div>
        </div>
      </div>
    </section>
  );
};
